import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  SideNavComponent,
  HeaderComponent,
  FooterComponent,
} from '../../../shared';

@Component({
  selector: 'app-main',
  imports: [SideNavComponent, HeaderComponent, FooterComponent],
  standalone: true,
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainComponent {}
